
import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showText?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  className = '', 
  showText = true 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <img 
        src="/lovable-uploads/5ab469fb-8911-4f16-b741-0cf91608349c.png" 
        alt="Genova AI Studio" 
        className={`${sizeClasses[size]} object-contain`}
        style={{ imageRendering: 'auto', transform: 'translateZ(0)' }}
        loading="lazy"
        width={size === 'xl' ? 64 : size === 'lg' ? 48 : size === 'md' ? 40 : 32}
        height={size === 'xl' ? 64 : size === 'lg' ? 48 : size === 'md' ? 40 : 32}
        decoding="async"
      />
      {showText && (
        <span className={`${textSizeClasses[size]} font-bold bg-gradient-to-r from-purple-600 via-pink-500 to-blue-500 bg-clip-text text-transparent`}>
          Genova AI Studio
        </span>
      )}
    </div>
  );
};
